import React from 'react';
import { Link } from 'react-router-dom';
import { BrandLockup } from '@/components/brand/BrandMark';

export default function PrivacyPage() {
  return (
    <div className="min-h-screen bg-background">
      <header className="border-b border-border px-6 py-4">
        <Link to="/"><BrandLockup /></Link>
      </header>
      <main className="max-w-3xl mx-auto px-6 py-10 space-y-6">
        <div>
          <p className="text-sm text-muted-foreground">Effective August 16, 2026</p>
          <h1 className="text-2xl font-semibold mt-1">Privacy Policy</h1>
        </div>

        <section className="space-y-2">
          <h2 className="text-lg font-medium">Who operates this service</h2>
          <p className="text-sm text-muted-foreground">
            FlexiClean LLC provides cleaning and vacation-rental turnover services on
            Florida's Emerald Coast. Questions or privacy requests can be sent to{' '}
            <a href="mailto:info@flexicleanpro.com" className="text-primary underline">info@flexicleanpro.com</a>{' '}
            or <a href="tel:+18509057223" className="text-primary underline">(850) 905-7223</a>.
          </p>
        </section>

        <section className="space-y-2">
          <h2 className="text-lg font-medium">Information we collect</h2>
          <p className="text-sm text-muted-foreground">
            When you book a service, use the customer portal, or contact us, you may
            provide your name, email, phone number, property details, requested
            service, timing, notes, and communication preferences.
          </p>
        </section>

        <section className="space-y-2">
          <h2 className="text-lg font-medium">Text (SMS) messages</h2>
          <p className="text-sm text-muted-foreground">
            If you provide a mobile number and opt in to service texts (appointment
            and arrival updates, invoices, payment reminders), that mobile
            information is used only to send those messages. We do not share or
            sell mobile opt-in information with third parties or affiliates for
            marketing or promotional purposes. Message frequency varies with your
            active bookings — typically a few messages per scheduled service.
            Message and data rates may apply. Reply STOP at any time to opt out, or
            HELP for help.
          </p>
        </section>

        <section className="space-y-2">
          <h2 className="text-lg font-medium">Service providers and disclosures</h2>
          <p className="text-sm text-muted-foreground">
            Information may be processed by providers that help operate our
            services: hosting providers, Twilio for SMS delivery, and our email
            provider. FlexiClean does not sell personal information.
          </p>
        </section>

        <section className="space-y-2">
          <h2 className="text-lg font-medium">Your choices</h2>
          <p className="text-sm text-muted-foreground">
            You may ask to access, correct, or delete information you provided by
            emailing us. You may decline optional text messages at any time by
            replying STOP.
          </p>
        </section>

        <section className="space-y-2">
          <h2 className="text-lg font-medium">Changes to this notice</h2>
          <p className="text-sm text-muted-foreground">
            We may update this notice when our practices change. The effective date
            above identifies the current version.
          </p>
        </section>
      </main>
    </div>
  );
}
